import * as NotificationActions from '../actions/notification.actions';
import {NotificationStats} from '../../../shared/models/notification-stats';
import { Notification } from '../../../shared/models/notification';

export interface State {
  notifications: Notification[] | null;
  stats: NotificationStats | null;
  error: any;
  areLoading: boolean;
}

export const initialState: State = {
  notifications: null,
  stats: new NotificationStats(0, 0, 0),
  error: null,
  areLoading: false,
};
export function reducer(
  state = initialState,
  action: NotificationActions.NotificationActionsUnion
): State {
  switch (action.type) {
    case NotificationActions.getNotifications.type:
    case NotificationActions.loadMoreNotifications.type: {
      return {
        ...state,
        areLoading: true,
      };
    }
    case NotificationActions.getNotificationsSuccess.type:
    case NotificationActions.loadMoreNotificationsSuccess.type: {
      return {
        ...state,
        notifications: action['notifications'],
        stats: action['stats'],
        areLoading: false,
      };
    }
    case NotificationActions.getNotificationsFailure.type:
    case NotificationActions.getNotificationByIdsFailure.type:
    case NotificationActions.loadMoreNotificationsFailure.type:
    case NotificationActions.updateNotificationsStatusFailure.type: {
      return {
        ...state,
        error: action['error'],
        areLoading: false,
      };
    }
    case NotificationActions.setNotificationsStats.type: {
      return {
        ...state,
        stats: action['stats']
      };
    }
    case NotificationActions.updateNotification.type: {
      const list: Notification[] = Object.assign([], state.notifications);
      const notification = list.find( x => x.notificationId === action.notification.notificationId);
      if (notification) {
        notification.notificationStatus = action.notification.notificationStatus;
      }
      return {
        ...state,
        notifications: state.notifications
      };
    }
    case NotificationActions.updateNotificationsStatusSuccess.type: {
      const list: Notification[] = Object.assign([], state.notifications);

      action?.notifications?.forEach(item => {
        const notification = list.find( x => x.notificationId === item.notificationId);
        if (notification) {
          notification.notificationStatus = item.notificationStatus;
        }
      })
      return {
        ...state,
        notifications: list
      };
    }
    case NotificationActions.getNotificationByIdsSuccess.type:
    case NotificationActions.pushNotificationSuccess.type: {
      return {
        ...state,
        notifications: action.notifications
      };
    }
    default: {
      return state;
    }
  }
}
export const getNotifications = (state: State) => state.notifications;
export const getStats = (state: State) => state.stats;
export const areLoading = (state: State) => state.areLoading;

